import React, { ReactElement } from 'react';
import { RegisterWrapper } from '../../features/auth/RegisterWrapper';

interface ContentProps {}

function Content({}: ContentProps): ReactElement {
  return <RegisterWrapper />;
}

export { Content };
